import React from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles, tokens } from '@fluentui/react-components';
import { Home24Regular, DocumentAdd24Regular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  nav: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
    alignItems: 'center',
  },
  navLink: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    textDecoration: 'none',
    color: 'var(--color-text-primary)',
    borderRadius: tokens.borderRadiusMedium,
    transition: 'all 0.2s ease',
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightRegular,
    ':hover': {
      backgroundColor: 'var(--color-surface-hover)',
    },
  },
  activeLink: {
    backgroundColor: 'var(--color-surface-selected)',
    fontWeight: tokens.fontWeightSemibold,
    color: 'var(--color-text-primary)',
  },
});

interface NavigationProps {
}

/**
 * Navigation component with links to different pages in the application.
 */
export const Navigation: React.FC<NavigationProps> = () => {
  const classes = useStyles();

  return (
    <nav className={classes.nav}>
      <NavLink
        to="/"
        className={({ isActive }) => 
          `${classes.navLink} ${isActive ? classes.activeLink : ''}`
        }
        end
      >
        <Home24Regular />
        <span>Home</span>
      </NavLink>
      <NavLink
        to="/documents"
        className={({ isActive }) => 
          `${classes.navLink} ${isActive ? classes.activeLink : ''}`
        }
      >
        <DocumentAdd24Regular />
        <span>Documents</span>
      </NavLink>
    </nav>
  );
};
